export default __webpack_public_path__ + "static/media/monica.28435645.gif";